<template>
	<div class="alarm-config-rule" :class="{ disabled }">
		<el-form ref="ruleForm" label-position="top" :model="formData" :disabled="disabled" style="padding: 0">
			<div class="operate-group" v-if="!disabled">
				<el-button type="primary" @click="handleInsertRule()" v-if="!configRuleList.length">添加规则</el-button>
			</div>
			<div class="setting-rule-content">
				<el-tree
					:data="configRuleList"
					node-key="conditionId"
					default-expand-all
					:expand-on-click-node="false"
					:indent="12"
					:props="{ children: 'conditions' }"
				>
					<div class="config-rule-item" slot-scope="{ node, data }">
						<div class="condition-operate-group" v-if="data.conditions && data.conditions.length > 0">
							<el-radio-group v-model="data.logicOperator">
								<el-radio-button label="AND"></el-radio-button>
								<el-radio-button label="OR"></el-radio-button>
							</el-radio-group>
							<div class="btns">
								<el-button type="text" v-if="!disabled" @click="handleInsertRule(data)">
									添加规则
								</el-button>
							</div>
						</div>
						<div v-else class="content">
							<el-form-item
								:prop="`conditions[${node.parent.data.conditions.indexOf(data)}].attributeKey`"
								:rules="rules.attributeKey"
								class="inline-form-item"
							>
								<el-select
									class="small-select-input"
									v-model="data.attributeKey"
									placeholder="请选择"
									@change="handleChangeAttributeKey(data, node)"
								>
									<el-option
										v-for="item in attributeOptionList"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item
								:prop="`conditions[${node.parent.data.conditions.indexOf(data)}].operator`"
								:rules="rules.operator"
								class="inline-form-item"
							>
								<el-select class="small-select-input" v-model="data.operator" placeholder="请选择">
									<el-option
										v-for="item in getOperatorOptions(data.attributeKey)"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item
								v-if="['0', '2', '20', '22'].includes(getCollectAttribute(data.attributeKey).valueType)"
								:prop="`conditions[${node.parent.data.conditions.indexOf(data)}].value`"
								:rules="
									[
										...rules.value,
										getCollectAttribute(data.attributeKey).inputCheck
											? {
													pattern: getCollectAttribute(data.attributeKey).inputCheck.reg,
													message: getCollectAttribute(data.attributeKey).inputCheck.regMsg,
											  }
											: null,
									].filter(Boolean)
								"
								class="inline-form-item"
							>
								<!-- 输入框控件 -->
								<el-input
									v-if="['0', '20'].includes(getCollectAttribute(data.attributeKey).valueType)"
									class="small-select-input"
									v-model="data.value"
									placeholder="请输入"
								></el-input>
								<!-- 下拉选择控件 -->
								<el-select
									v-if="['2', '22'].includes(getCollectAttribute(data.attributeKey).valueType)"
									class="small-select-input"
									v-model="data.value"
									placeholder="请选择"
								>
									<el-option
										v-for="item in Object.entries(
											getCollectAttribute(data.attributeKey).interactiveTranslationDes || {},
										)"
										:key="item[0]"
										:label="item[1]"
										:value="item[0]"
									></el-option>
								</el-select>
							</el-form-item>
							<span class="unit" v-if="getCollectAttribute(data.attributeKey).unit">
								{{ getCollectAttribute(data.attributeKey).unit }}
							</span>
							<div class="btns" v-if="!disabled">
								<el-button type="text" class="delete" @click="handleRemoveConfirRule(node, data)">
									删除
								</el-button>
							</div>
						</div>
					</div>
				</el-tree>
			</div>

			<!-- 表达式预览 -->
			<div class="expression-preview" v-if="expressionText">
				<span class="preview-label">表达式预览：</span>
				<span class="preview-content">{{ expressionText }}</span>
			</div>
		</el-form>
	</div>
</template>

<script>
import { randomString } from '@/utils'
import { isBlank } from '@/utils/validate'
import { ruleRequired } from '@/utils/rules'
import { apiGetConfigCollectAttributes } from '@/apis/alarm.api'

export default {
	name: 'AlarmConfigRule',
	props: {
		deviceTypeId: Number,
		eventExpression: String,
		disabled: Boolean,
	},
	data() {
		return {
			attributeOptionList: [],
			configRuleList: [],
			formData: {
				conditions: [],
			},
			rules: {
				attributeKey: [ruleRequired('请选择字段', 'change')],
				operator: [ruleRequired('请选择操作符', 'change')],
				value: [ruleRequired('请输入数值', 'blur')],
			},
		}
	},

	created() {
		this.getConfigCollectAttributes()
	},

	methods: {
		getOperatorOptions(attributeKey) {
			const attributeItem = this.getCollectAttribute(attributeKey) || {}
			const options = [
				{ label: '等于', value: 'EQ' },
				{ label: '小于', value: 'LT' },
				{ label: '小于等于', value: 'LTE' },
				{ label: '大于', value: 'GT' },
				{ label: '大于等于', value: 'GTE' },
				{ label: '不等于', value: 'NE' },
			]
			const operatorValuesByValueType = {
				2: ['EQ', 'NE'],
				20: ['GTE'],
				22: ['EQ'],
			}
			const operatorValues = operatorValuesByValueType[attributeItem.valueType]
			return operatorValues ? options.filter(m => operatorValues.includes(m.value)) : options
		},

		async getConfigCollectAttributes() {
			const data = await apiGetConfigCollectAttributes(this.deviceTypeId)
			this.attributeOptionList = data.map(m => {
				return {
					...m,
					label: m.name,
					value: m.attributeKey,
				}
			})
		},

		handleInsertRule(configRuleData) {
			if (!configRuleData) {
				this.configRuleList = [
					{
						conditionId: randomString(),
						logicOperator: 'AND',
						nodeType: 'LOGIC_GROUP',
						conditions: [
							{
								conditionId: randomString(),
								attributeKey: '',
								operator: '',
								value: undefined,
								nodeType: 'CONDITION',
							},
						],
					},
				]
			} else {
				if (configRuleData.conditions.length === 2)
					return this.$message.warning('当前规则设置最多只能添加两个字段')
				configRuleData.conditions.push({
					conditionId: randomString(),
					attributeKey: '',
					operator: '',
					value: undefined,
					nodeType: 'CONDITION',
				})
			}
		},

		handleRemoveConfirRule(node, configRuleData) {
			const parent = node.parent
			const conditions = parent.data.conditions || parent.data
			const index = conditions.findIndex(d => d.conditionId === configRuleData.conditionId)
			conditions.splice(index, 1)
			if (parent.data === this.configRuleList[0] && conditions.length === 0) {
				this.configRuleList = []
			}
		},

		getCollectAttribute(attributeKey) {
			if (!attributeKey) return {}
			return this.attributeOptionList.find(m => m.attributeKey === attributeKey) || {}
		},

		handleChangeAttributeKey(data, node) {
			data.operator = ''
			data.value = ''
			const index = node.parent.data.conditions.indexOf(data)
			this.$nextTick(() => {
				this.$refs.ruleForm.clearValidate([`conditions[${index}].operator`, `conditions[${index}].value`])
			})
		},

		validate() {
			return new Promise((resolve, reject) => {
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						resolve(this.configRuleList[0])
					} else {
						reject(new Error('表单校验失败'))
					}
				})
			})
		},

		clearValidate() {
			this.$refs.ruleForm.clearValidate()
		},

		getConfigData() {
			return this.configRuleList
		},
	},

	watch: {
		configRuleList: {
			handler() {
				if (this.configRuleList.length > 0) {
					this.formData.conditions = this.configRuleList[0].conditions
				} else {
					this.formData.conditions = []
				}
			},
			deep: true,
			immediate: true,
		},

		deviceTypeId(newVal) {
			if (newVal) {
				this.getConfigCollectAttributes()
			}
		},

		eventExpression: {
			handler(newVal) {
				if (newVal) {
					this.configRuleList = [JSON.parse(this.eventExpression)]
				} else {
					this.configRuleList = []
				}
			},
			immediate: true,
		},
	},

	computed: {
		expressionText() {
			if (!this.configRuleList.length) return ''

			const group = this.configRuleList[0]
			if (!group.conditions || !group.conditions.length) return ''

			// 获取中英文映射
			const getLabel = (value, options) => {
				const item = options.find(opt => opt.value === value)
				return item ? item.label : value
			}

			const getUnit = (value, options) => {
				const item = options.find(opt => opt.value === value)
				return item?.unit || ''
			}

			const getInteractiveTranslationDes = (value, options) => {
				const item = options.find(opt => opt.value === value)
				return item?.interactiveTranslationDes
			}

			// 生成单个条件的表达式
			const buildCondition = child => {
				const attributeKey = getLabel(child.attributeKey, this.attributeOptionList)
				const operator = getLabel(child.operator, this.getOperatorOptions())
				const interactiveTranslationDes = getInteractiveTranslationDes(
					child.attributeKey,
					this.attributeOptionList,
				)
				const value = !isBlank(child.value)
					? interactiveTranslationDes
						? interactiveTranslationDes[child.value]
						: child.value
					: '__'
				const unit = getUnit(child.attributeKey, this.attributeOptionList)
				return `${attributeKey}${operator}${value}${unit}`
			}

			// 过滤出有效的条件（已选择告警名称和操作符的）
			const validConditions = group.conditions.filter(child => child.attributeKey && child.operator)

			if (!validConditions.length) return ''

			// 生成表达式，用 AND/OR 连接
			const conditionText = validConditions
				.map(buildCondition)
				.join(` ${group.logicOperator === 'AND' ? '且' : '或'} `)

			return conditionText
		},
	},
}
</script>
<style lang="scss" scoped>
.alarm-config-rule {
	padding: 12px 0;

	&.disabled {
		.content {
			background-color: #e4e4e4 !important;
		}
	}
	.operate-group {
		text-align: right;
		.el-button {
			height: auto;
			padding: 8px 12px;
			border-radius: 6px !important;
		}
	}
	.setting-rule-content {
		border: 1px solid #ebeef5;
		border-radius: 6px;
		margin-top: 12px;
		padding: 12px;
		::v-deep.el-tree {
			.el-tree-node__content {
				height: auto;
				background-color: transparent !important;
				.config-rule-item {
					flex: 1;
					width: 0;
					.condition-operate-group {
						display: flex;
						align-items: center;
						.btns {
							margin-left: auto;
							flex-shrink: 0;
						}
					}
					.content {
						display: flex;
						align-items: center;
						background-color: rgb(249, 250, 251);
						padding: 10px 8px;
						border-radius: 4px;
						margin-top: 4px;
						margin-bottom: 4px;
						position: relative;
						gap: 6px;
						.inline-form-item {
							display: inline-block;
							margin-bottom: 0;
							::v-deep .el-form-item__content {
								line-height: normal;
							}
						}
						.small-select-input {
							width: 170px;
							.el-input__inner {
								text-align: left !important;
							}
						}
						.unit {
							color: #999;
							font-size: 12px;
							margin-left: 0;
						}
						.btns {
							margin-left: auto;
							flex-shrink: 0;
							.delete {
								color: #f56c6c;
							}
						}
					}
				}
			}
		}
	}
	.expression-preview {
		margin-top: 12px;
		padding: 12px;
		background-color: #f0f9ff;
		border: 1px solid #b3d8ff;
		border-radius: 6px;
		font-size: 14px;
		.preview-label {
			color: #409eff;
			font-weight: 500;
			margin-right: 8px;
		}
		.preview-content {
			color: #333;
		}
	}
}
</style>
